import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { NeuApp } from '@neutron/react';
import Header from './components/header/Header';
import React from 'react';
import { fetchAccessToken, fetchToken } from './services/AuthenticationService';
import { fetchUserInfo } from './services/UserService';
import Dashboard from './pages/dashboard/dashboard';
import DialogBox from './components/dialogbox/dialogbox';
import Loader from './components/loader/Loader';
import { RESPONSE_SUCESS } from './shared/constants/response-constants';
import NF400 from './pages/nfpages/nf400';
import NF500 from './pages/nfpages/nf500';
import NF401 from './pages/nfpages/nf401';
import moment from 'moment';
import usePermission from './shared/hooks/usePermission';
import NoAccess from './pages/noaccess/noaccess';
import AccountSearch from './pages/account/shared/AccountSearch';
import useApi from './hooks/use-api';
import { APIResponseOfListOfAlertListDTO, ActiveSystemAlertRequest, APIResponseOfListOfRoot, IRoot, APIResponseOfCommonConfiguration, DropDownItem } from './services/generated';
import { DateToCST, getAllNodes } from './shared/hooks/utils';
import AlertNotification, { NotificationInputData } from './components/alert-notification/AlertNotification';
import { GridContainer } from './components/grid/Grid';
import { PreRegistrationContext } from './pages/pre-registration/PreRegistrationContext';
import { IPreRegistrationContextValue } from './shared/interfaces/PreRegistrationContextValue';
import { WorkqueueContext } from './pages/workqueue/WorkqueueContext';
import { IWorkqueueContextValue } from './shared/interfaces/WorkQueue';
import { ConversationContext, ConversationIdKey } from './pages/account/appointments/ConversationContext';
import { Module } from './shared/constants/ui-constants';
import useApiFeedback from './shared/hooks/useApiFeedback';
import { clearApiFeedbackError } from './services/api-feedback';
import './App.scss';
import ExceptionPage from './components/exception-page/ExceptionPage';
import { Snackbar } from './components/snackbar/Snackbar';

const WorkQueue = React.lazy(() => import('./pages/workqueue/WorkQueue'));
const PreRegistration = React.lazy(() => import('./pages/pre-registration/PreRegistration'));
const Maintenance = React.lazy(() => import('./pages/maintenance/Maintenance'));
const AccountDetailsPage = React.lazy(() => import('./pages/account/AccountDetails'));

function App() {
  const [isLoaded, setLoaded] = useState<boolean>(false);
  const isExpired: boolean = false;
  const [loadedFacilities, setFacilities] = useState<Array<IRoot>>();
  const [isSearchVisible, setIsSearchVisible] = useState<boolean>(false);
  const [isSearchMinimized, setIsSearchMinimized] = useState<boolean>(false);
  let [loggedInUser, setLoggedInUser] = useState<any>();
  const [alertData, setAlertData]  = useState<Array<NotificationInputData>>();
  const { setUser } = usePermission();
  const { facility: facilityClient, alert: alertClient, user: userClient } = useApi();
  let navigate = useNavigate();
  // const [authorizationValue, setAuthorizationValue] = useState<IAuthorzaitionContextValue>({});
  const [workqueueValue, setWorkqueueValue] = useState<IWorkqueueContextValue>({});
  const [preRegValue, setPreRegValue] = useState<IPreRegistrationContextValue>({});
  const [conversationId, setConversationId] = useState<string | null>(null);
  const [dismissedApiErrorId, setDismissedApiErrorId] = useState<number>(0);
  const { errorMessage: apiErrorMessage, errorId: apiErrorId } = useApiFeedback();
  let global: any = globalThis;

  const dialogBoxData: any = {
    title: 'Alert..!',
    message: 'Session expired..! You will be redirecting to homepage'
  };

  const loadFacilities = async () => {
    const response: APIResponseOfListOfRoot = await facilityClient.getUserFacilities(null);
    if (response.statusCode === RESPONSE_SUCESS && response.result) {
      setFacilities(response.result);
    } else {
      navigate({ pathname: 'pagenotfound500' });
    }
  };

  const loadUserConfiguration = async () => {
    const response: APIResponseOfCommonConfiguration = await userClient.getCommonConfiguration();
    if (response.statusCode === RESPONSE_SUCESS && response.result && response.result) {
        global.userConfiguration =  response.result;
    }
  }

  const setLoginData = async () => {
    const data: any = await fetchUserInfo();
    if (data !== null && data !== undefined) {
      if (!data.payload) {
        localStorage.clear();
        const originURL = window.location.origin;
        window.location.href = originURL;
      } else if (data?.payload === null) {
        setLoaded(true);
        setUser({
          id: '',
          userPermissions: []
        });
        navigate({ pathname: 'noaccess' });
      } else if (data?.payload.permission === '' && data?.payload.userPermissions.length === 0) {
        setLoaded(true);
        setUser({
          id: '',
          userPermissions: []
        });
        navigate({ pathname: 'noaccess' });
      } else {
        setLoggedInUser(data?.payload);
        global.userDetails = data.payload;
        global.resetWorkQueueValue = true;
        setLoaded(true);
        loadFacilities();
        setUser({
          id: data.payload.userID,
          userPermissions: data.payload.userPermissions
        });
        const redirectUrl = sessionStorage.getItem('redirectUrl');
        const currentPath = window.location.pathname + window.location.search;
        if (redirectUrl && redirectUrl !== currentPath) {
          sessionStorage.removeItem('redirectUrl');
          navigate(redirectUrl);
        }
        sessionStorage.removeItem('redirectUrl');
      }
    } else {
      setLoaded(true);
      setUser({
        id: '',
        userPermissions: []
      });
      return "error";
    }
  };

  const onClickOK = (e: boolean) => {
    if (e) {
      localStorage.clear();
      const originURL = window.location.origin;
      window.location.href = originURL;
    }
  };

  const setSearchActive = (e: any) => {
    setIsSearchVisible(e);
    if (e) {
      setIsSearchMinimized(false);
    }
  };

  const onCloseSearch = (e: any) => {
    // if (e) {
      setIsSearchVisible(false);
    // }
  };

  const onMinimizeSearch = (e: any) => {
    if (e) {
      setIsSearchMinimized(e);
    } else {
      setIsSearchMinimized(false);
      setIsSearchVisible(true);
    }
  };

  const getSystemAlerts = async () => {
    const payload: ActiveSystemAlertRequest =  new ActiveSystemAlertRequest({
      pageNumber: 1,
      pageSize: 10
    })
    const response : APIResponseOfListOfAlertListDTO = await alertClient.getActiveSystemAlerts(null, payload)
    if (response.statusCode === RESPONSE_SUCESS && response.result) {
      let result: Array<NotificationInputData> = [];
      response.result.forEach(element => {
        const alertDate: Date | undefined = element.modifiedDate ? element.modifiedDate : element.createdDate;
        const alertBy:  string | undefined = element.modifiedBy ? element.modifiedBy : element.createdBy;
        const alertState: string = element.modifiedBy ? 'Updated' : 'Posted';
        const data: NotificationInputData = {
          icon: 'warning',
          message: element.alertText!,
          suffixmessage: alertState + ' on ' + DateToCST(alertDate!.toString(), 'MM/DD/YYYY hh:mm A') + ' by ' + alertBy
        }
        result.push(data);
      });
      setAlertData(result)
    }
  }

  const onCloseAlert = () => {
    setAlertData([]);
  }

  const onCloseApiErrorAlert = (mode: string) => {
    setDismissedApiErrorId(apiErrorId);
    if(mode === 'refresh') {
      clearApiFeedbackError();
      window.location.reload();
    }
    
  };

  useEffect(() => {
    if (!sessionStorage.getItem('redirectUrl')) {
      // Set 'redirectUrl' with the current page's pathname and search parameters
      sessionStorage.setItem('redirectUrl', window.location.pathname + window.location.search);
    }
    const params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    var accessToken = localStorage.getItem('access_token');
    var accesstokenexpiry = localStorage.getItem('accesstoken_expiry');
    if (accesstokenexpiry) {
      var currentTime = moment();
      var timeStore = moment(new Date(accesstokenexpiry));
      var timediff = currentTime.diff(timeStore, 'h');
      if (timediff > 23) {
        localStorage.clear();
        code = null;
        accessToken = null;
      }
    }

    if (!code && !accessToken) {
      fetchToken();
    } else if (code) {
      fetchAccessToken(code);
    } else if (accessToken) {
      setLoginData().then((res: string | undefined) => {
        if (res == 'error') {
          navigate({ pathname: 'pagenotfound500' });
        }
        else {
          getSystemAlerts();
          loadUserConfiguration();
        }
      });
    } else {
      setLoaded(true);
      setUser({
        id: '',
        userPermissions: []
      });
      navigate({ pathname: 'pagenotfound500' });
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search.toLowerCase());
    const conversationId = params.get(ConversationIdKey.toLowerCase());
    if (conversationId) {
      setConversationId(conversationId);
    }
  }, []);
  

  return (
    <NeuApp header="sticky" id="mainContent">
      <ConversationContext.Provider value={{ conversationId, setConversationId }}>
      <div className={alertData?.length! > 0 ? 'alert-section-active mainContentInner' : 'mainContentInner'}>
        <NeuApp unit="header">
          <WorkqueueContext.Provider value={{workqueueValue, setWorkqueueValue}}>
            <Header userInfo={loggedInUser} isSearchActive={isSearchVisible} updateSearchStatus={(e: any) => setSearchActive(e)} />
          </WorkqueueContext.Provider>
        </NeuApp>
        <NeuApp unit="content">
          {isExpired && <DialogBox type={'notification'} data={dialogBoxData} isSubmitted={onClickOK} />}
          {apiErrorMessage && apiErrorId > dismissedApiErrorId && <Snackbar kind="error" label="Error" 
            teleport message={apiErrorMessage} buttonText="Refresh"
            onDismiss={() => {
                onCloseApiErrorAlert('close');
            }}
            onClick={() => {
                onCloseApiErrorAlert('refresh');
            }}
          />}
          {!isLoaded ? <Loader /> : <React.Fragment>
              <AlertNotification color={'red-60'} isCloseable={false} onCloseAlert={onCloseAlert} items={alertData!} />
              {isSearchVisible && (
                <div className={isSearchMinimized ? 'hide-search-result-panel search-result-panel w-100' : 'search-result-panel w-100'}>
                  <AccountSearch onMinimizeBtnClick={onMinimizeSearch} onCloseBtnClick={onCloseSearch} />
                </div>
              )}
              <div className={!isSearchVisible || isSearchMinimized ? 'router-wrapper w-100' : 'd-none w-100'}>
                <Routes>
                  <Route path="/pagenotfound500" element={<div className="page-wrapper"><NF500 /></div>} />
                  <Route path="/pagenotfound400" element={<div className="page-wrapper"><NF400 /></div>} />
                  <Route path="/pagenotfound401" element={<div className="page-wrapper"><NF401 /></div>} />
                  <Route
                    path="/noaccess"
                    element={ <div className="page-wrapper"><NoAccess /></div>
                    }
                  />
                  <Route
                    path="/"
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <Dashboard />
                      </React.Suspense>
                    }
                  />
                  <Route
                    path="/workqueue"
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <WorkqueueContext.Provider value={{workqueueValue, setWorkqueueValue}}>
                          <WorkQueue facilities={loadedFacilities!} />
                        </WorkqueueContext.Provider>
                      </React.Suspense>
                    }
                  />
                  <Route
                    path="/pre-registration/*"
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <WorkqueueContext.Provider value={{workqueueValue, setWorkqueueValue}}>
                          <PreRegistrationContext.Provider value={{preRegValue, setPreRegValue}}>
                            <PreRegistration facilities={loadedFacilities!} />
                          </PreRegistrationContext.Provider>
                        </WorkqueueContext.Provider>
                      </React.Suspense>
                    }
                  />
                  <Route
                    path="/workqueue/account/*"
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <WorkqueueContext.Provider value={{workqueueValue, setWorkqueueValue}}>
                          <PreRegistrationContext.Provider value ={{preRegValue,setPreRegValue}}>
                            <GridContainer className='page-wrapper workqueue-wrapper' fluid>
                              <AccountDetailsPage module={Module.WorkQueues}/>
                            </GridContainer>
                          </PreRegistrationContext.Provider>
                        </WorkqueueContext.Provider>
                      </React.Suspense>
                    }
                  />
                  <Route
                    path="/account/*"
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <WorkqueueContext.Provider value={{workqueueValue, setWorkqueueValue}}>
                          <PreRegistrationContext.Provider value ={{preRegValue,setPreRegValue}}>
                            <GridContainer className='page-wrapper' fluid>
                              <AccountDetailsPage />
                            </GridContainer>
                          </PreRegistrationContext.Provider>
                        </WorkqueueContext.Provider>
                      </React.Suspense>
                    }
                  />
                  <Route
                    path="/maintenance/*"
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <Maintenance facilities={getAllNodes(loadedFacilities!, false) as DropDownItem[]} onAlertCreation={getSystemAlerts} />
                      </React.Suspense>
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <div className="page-wrapper">
                        <ExceptionPage
                          title={"Target not found"} 
                          description={"The route specified in the URL does not exist.\nPlease return to the homepage and try navigating to your destination again."} 
                          showHomebutton />
                      </div>
                    }
                  />
                </Routes>
              </div>
            </React.Fragment>
          }
        </NeuApp>
      </div>
      </ConversationContext.Provider>
    </NeuApp>
  );
}

export default App;
